var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "account_circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.69232C6.48 2.69232 2 7.17232 2 12.6923C2 18.2123 6.48 22.6923 12 22.6923C17.52 22.6923 22 18.2123 22 12.6923C22 7.17232 17.52 2.69232 12 2.69232ZM7.35 19.1923C8.66 18.2523 10.26 17.6923 12 17.6923C13.74 17.6923 15.34 18.2523 16.65 19.1923C15.34 20.1323 13.74 20.6923 12 20.6923C10.26 20.6923 8.66 20.1323 7.35 19.1923ZM18.14 17.8123C16.45 16.4923 14.32 15.6923 12 15.6923C9.68 15.6923 7.55 16.4923 5.86 17.8123C4.7 16.4223 4 14.6423 4 12.6923C4 8.27232 7.58 4.69232 12 4.69232C16.42 4.69232 20 8.27232 20 12.6923C20 14.6423 19.3 16.4223 18.14 17.8123Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.69232C10.07 6.69232 8.5 8.26232 8.5 10.1923C8.5 12.1223 10.07 13.6923 12 13.6923C13.93 13.6923 15.5 12.1223 15.5 10.1923C15.5 8.26232 13.93 6.69232 12 6.69232ZM12 11.6923C11.17 11.6923 10.5 11.0223 10.5 10.1923C10.5 9.36232 11.17 8.69232 12 8.69232C12.83 8.69232 13.5 9.36232 13.5 10.1923C13.5 11.0223 12.83 11.6923 12 11.6923Z",
    fill: "#475569"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.a4d7f36f62fb5626da2112e7ed474d41.svg";
export { ForwardRef as ReactComponent };